import { type JSX } from 'react';
import { failureMessage } from '../lib/error-labels.ts';

/**
 * A SAVE THAT FAILED SAYS SO WHERE IT WAS MADE. Placed directly under the control whose
 * mutation it reads: one page-level message at the top went unseen by an owner changing a
 * setting further down, who saw the value spring back and nothing else (prod FB-0109).
 */
export function SaveError(props: { readonly mutation: { readonly error: unknown } } & (
  | { readonly fallback: string }
  | { readonly message: (error: unknown) => string }
)): JSX.Element | null {
  const { error } = props.mutation;
  if (!error) return null;
  return (
    <p role="alert" data-testid="save-error" className="mt-2 text-sm text-destructive">
      {'message' in props ? props.message(error) : failureMessage(error, props.fallback)}
    </p>
  );
}
